/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    stroke?: string
}

interface State {}

export default class ShareIcon extends React.Component<Props, State> {

    public render() {

        let {
            stroke = '#000',
            width = 20,
            height = 20
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
                <g id="Layer_2_22_">
                    <path d="M20.6 6.6V24H3.4V6.6h6.4v1H4.4V23h15.2V7.6h-5.4v-1z" stroke={stroke}/>
                    <path d="M16 4.2l-.7.7-2.8-2.8v13.2h-1V2.1L8.8 4.9 8 4.2l4-4z" stroke={stroke}/>
                </g>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Share.tsx